import type { InstructorLesson } from '../types';

// Créneau à réserver : règle d'affichage pure, sans écran ni date de la bibliothèque.

/**
 * Créneau à réserver encore proposé aux élèves, donc annoncé « Ouvert à la réservation ». Le
 * serveur le dit (`bookable` : la règle de la réservation, moniteur actif compris) ; l'écran
 * vérifie seulement qu'il n'a pas commencé depuis le chargement. Sans `bookable` (serveur plus
 * ancien), le statut et l'heure décident.
 */
export function isOfferedOpenSlot(
  lesson: Pick<InstructorLesson, 'isOpenSlot' | 'status' | 'startsAt' | 'bookable'>,
  now = Date.now(),
): boolean {
  return (
    lesson.isOpenSlot &&
    lesson.bookable !== false &&
    lesson.status !== 'cancelled' &&
    Date.parse(lesson.startsAt) > now
  );
}
